import * as React from "react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/InstructorsPage.css";
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import BasicModal from "../components/BasicModal";
import axios from "axios";

function InstructorsPage() {
    const [instructors, setInstructors] = useState([]);
    const [selectedBio, setSelectedBio] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/instructors/get-all`)
            .then(response => {
                console.log(response.data);
                setInstructors(response.data);
            })
            .catch(error => console.error("Eğitmen verileri alınamadı:", error));
    }, []);

    const openModal = (bio) => {
        setSelectedBio(bio);
        setIsModalOpen(true);
    };

    const closeModal = () => setIsModalOpen(false);

    const handleTeachWithUs = () => {
        navigate('/instructor-registration');
    };

    return (
        <div className="instructors-page">
            {/* Hero Header Section */}
            <div className="instructors-hero">
                <div className="instructors-hero-content">
                    <h1>
                        <i className="fas fa-chalkboard-teacher"></i>
                        Eğitmenlerimiz
                    </h1>
                </div>
            </div>

            <div className="instructors-container">
                <div className="teach-with-us-section">
                    <p className="teach-description">
                        Siz de MeduVR ailesine katılmak ve deneyiminizi paylaşmak ister misiniz?
                    </p>
                    <button
                        className="teach-with-us-btn"
                        onClick={handleTeachWithUs}
                    >
                        <i className="fas fa-plus-circle"></i>
                        Bizimle Ders Verin
                    </button>
                </div>

                <div className="instructor-list">
                    {instructors.map((instructor) => (
                        <Card key={instructor.id} className="instructor-card modern-card">
                            <CardMedia
                                component="img"
                                alt={`${instructor.firstName} ${instructor.lastName}`}
                                image={instructor.imageUrl || '/images/default-instructor.svg'}
                                className="instructor-image"
                                onError={(e) => {
                                    e.target.src = '/images/default-instructor.svg';
                                }}
                            />
                            <CardContent className="instructor-content">
                                <Typography className="instructor-title">
                                    {instructor.title}
                                </Typography>
                                <Typography className="instructor-name">
                                    {`${instructor.firstName} ${instructor.lastName}`}
                                </Typography>
                                <Typography className="instructor-expertise">
                                    {instructor.expertise}
                                </Typography>
                                <Typography className="instructor-contact">
                                    📧 {instructor.email}
                                </Typography>
                            </CardContent>
                            <CardActions className="instructor-actions">
                                <Button
                                    className="avesis-btn"
                                    href={instructor.avesisUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    AVESIS
                                </Button>
                                <Button
                                    className="bio-btn"
                                    onClick={() => openModal(instructor.bio)}
                                >
                                    Özgeçmiş
                                </Button>
                            </CardActions>
                        </Card>
                    ))}
                </div>
            </div>

            <BasicModal
                isOpen={isModalOpen}
                onClose={closeModal}
                content={selectedBio}
                title="Eğitmen Özgeçmişi"
            />
        </div>
    );
}

export default InstructorsPage;
